<!-- user-actions-dialog.component.html -->
<div class="user-actions-container">
  <div class="dialog-header">
    <h2>My Actions</h2>
    <button mat-icon-button (click)="close()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="tabs-container">
    <div class="action-tabs">
      <button
        class="tab-button"
        [class.active]="currentTab === 'now'"
        [class.has-items]="filteredNowCount > 0"
        (click)="setTab('now')">
        <mat-icon>warning</mat-icon>
        <span>Now <span class="count">({{ filteredNowCount }})</span></span>
      </button>
      <button
        class="tab-button"
        [class.active]="currentTab === 'today'"
        [class.has-items]="filteredTodayCount > 0"
        (click)="setTab('today')">
        <mat-icon>schedule</mat-icon>
        <span>Today <span class="count">({{ filteredTodayCount }})</span></span>
      </button>
      <button
        class="tab-button"
        [class.active]="currentTab === 'all'"
        (click)="setTab('all')">
        <mat-icon>list</mat-icon>
        <span>All <span class="count">({{ filteredTotalCount }})</span></span>
      </button>
    </div>
  </div>

  <div class="actions-content">
    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="32"></mat-spinner>
      <p>{{ getLoadingMessage() }}</p>
    </div>

    <!-- Use async pipe with the observable -->
    <ng-container *ngIf="filteredActions$ | async as filteredActions">
      <div *ngIf="!loading && filteredActions.length === 0" class="empty-state">
        <mat-icon class="empty-icon">{{ currentTab === 'now' ? 'check_circle' : 'inbox' }}</mat-icon>
        <p>{{ currentTab === 'now' ? 'No urgent actions!' : 'No actions for ' + currentTab }}</p>
      </div>

      <div class="actions-list" [@listAnimation]="filteredActions.length">
        <div 
          *ngFor="let action of filteredActions; trackBy: trackByActionId"
          class="action-item"
          [class.priority-now]="action.priority === 'NOW'"
          [class.priority-today]="action.priority === 'TODAY'"
          [class.new-action]="isNewAction(action)"
          [class.snoozing]="snoozingActionId === action.id"
          [@newItemAnimation]>
          
          <!-- Main action content -->
          <div class="action-main" (click)="handleAction(action)">
            <!-- Priority label on the left -->
            <span class="action-priority-left" [class.priority-now]="action.priority === 'NOW'">
              {{ action.priority }}
            </span>

            <div class="action-icon-wrapper" [class.color-warn]="action.priority === 'NOW'">
              <mat-icon>{{ getActionIcon(action) }}</mat-icon>
            </div>
            
            <div class="action-content">
              <h4 class="action-title">{{ action.title }}</h4>
              <p class="action-description" *ngIf="action.description">{{ action.description }}</p>
              <span class="action-time">
                <mat-icon class="tiny-icon">access_time</mat-icon>
                {{ getDisplayTime(action) | date:'M/d/yy, h:mm a' }}
              </span>
            </div>
          </div>

          <!-- Quick action buttons -->
          <div class="quick-actions">
            <button 
              mat-icon-button 
              *ngIf="currentTab === 'now'"
              class="snooze-btn"
              [matMenuTriggerFor]="snoozeMenu"
              (click)="quickSnooze($event, action)"
              matTooltip="Snooze options">
              <mat-icon>schedule</mat-icon>
            </button>
            
            <button 
              mat-icon-button 
              class="complete-btn"
              (click)="quickComplete($event, action)"
              [disabled]="isCompletingAnyAction"
              [matTooltip]="isCompletingAnyAction ? 'Please wait...' : 'Mark as complete'">
              <mat-icon>{{ isCompletingAnyAction ? 'hourglass_empty' : 'check_circle' }}</mat-icon>
            </button>
            
          </div>

          <!-- Snooze options menu -->
          <mat-menu #snoozeMenu="matMenu" class="snooze-quick-menu">
            <button mat-menu-item (click)="snoozeAction(action, 1)">
              <mat-icon>schedule</mat-icon>
              <span>1 hour </span>
              <span class="snooze-time-hint">{{getSnoozeTimeHint(1)}}</span>
            </button>
            <button mat-menu-item (click)="snoozeAction(action, 2)" class="default-option">
              <mat-icon>schedule</mat-icon>
              <span>2 hours </span>
              <span class="snooze-time-hint">{{getSnoozeTimeHint(2)}}</span>
            </button>
            <button mat-menu-item (click)="snoozeAction(action, 4)">
              <mat-icon>today</mat-icon>
              <span>4 hours </span>
              <span class="snooze-time-hint">{{getSnoozeTimeHint(4)}}</span>
            </button>
            <button mat-menu-item (click)="snoozeAction(action, 24)">
              <mat-icon>event</mat-icon>
              <span>Tomorrow </span>
              <span class="snooze-time-hint">{{getSnoozeTimeHint(24)}}</span>
            </button>
            <button mat-menu-item (click)="snoozeAction(action, 72)">
              <mat-icon>event</mat-icon>
              <span>3 days </span>
              <span class="snooze-time-hint">{{getSnoozeTimeHint(72)}}</span>
            </button>
            <mat-divider></mat-divider>
          </mat-menu>
        </div>

        <!-- End of list indicator -->
        <div *ngIf="!loading && filteredActions.length > 0" class="end-of-list">
          <mat-divider></mat-divider>
          <p class="end-message">
            <mat-icon>check_circle_outline</mat-icon>
            Showing all {{ getTabCount() }} actions
          </p>
        </div>
      </div>
    </ng-container>
  </div>
</div>